
import React from "react";

export function TroubleshootingTips() {
  return (
    <div className="mt-3 p-2 bg-blue-50 rounded border border-blue-200">
      <h4 className="font-semibold text-blue-800">Troubleshooting Tips:</h4>
      <ol className="list-decimal list-inside mt-1 text-blue-800">
        <li>Check if the 'subscriptions' table (lowercase) exists in Supabase</li>
        <li>Confirm table has all the required columns with correct data types</li>
        <li>Make sure Row Level Security (RLS) policies allow read access</li>
        <li>Consider running the migration script again if needed</li>
      </ol>
    </div>
  );
}
